import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserInfoService } from 'src/app/shared/UserInfo/user-info.service';
import { CitiesService } from 'src/app/core/cities/services/cities.service';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService, 
    private router: Router, 
    private citiesService: CitiesService,
    private userInfoService: UserInfoService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.authService.isLoggedIn()) {
      this.router.navigate(['/login']);
      return false;
    }
    const userInfo = this.userInfoService.getUserInfo();
    const selectedCity = this.citiesService.getUserSelectedCity();
    const restrictedCityId = route.data['restrictedCityId'];
    const allowedUserTypes = route.data['allowedUserTypes'] as number[] | undefined;
    
    if (restrictedCityId && selectedCity.id !== restrictedCityId) {
      this.router.navigate(['/orders-support']); 
      return false;
    }

    // Restricción por tipo de usuario
    if (allowedUserTypes && !allowedUserTypes.includes(userInfo.role.id)) {
      this.router.navigate(['/orders-create']); 
      return false;
    }

    return true;
  }
}